module.exports = __webpack_public_path__ + "app-static/img/icon-yhbcg.58b57400.png";